import { useQuery } from 'react-query';
import { getAvailableNavigation } from '../fetch';
import { IUser } from '../models';

export const useAllowedNavRoutes = (
  featureFlags: any,
  user?: IUser
): { availableLinks: Set<string>; isNavLoading: boolean } => {
  const { data, isLoading } = useQuery<string[], Error>(
    'getAvailableNavigation',
    getAvailableNavigation,
    {
      enabled: featureFlags?.authorizeUserNavigationAccess && !!user,
      cacheTime: 10 * 60 * 1000,
      refetchOnWindowFocus: true,
      refetchOnMount: 'always'
    }
  );
  return { availableLinks: new Set(data ?? []), isNavLoading: isLoading };
};
